<div class="modal-wrapper bs4">
  <div class="modal-header">
    <a class="close" (click)="dismiss()">&times;</a>
    <h3>{{ 'question_management.affiliation_modal.title' | translate }}</h3>
  </div>
  <div class="modal-body">
    <label>
      {{ 'questions.edit.affiliation' | translate }}
    </label>
    <ng-select-wrapper
      [options]="affiliations"
      (valueChange)="affiliationId = $event"
    ></ng-select-wrapper>
  </div>
  <div class="modal-footer">
    <button (click)="dismiss()" class="btn btn-secondary-migrated">
      {{ 'common.actions.cancel' | translate }}
    </button>
    <button
      (click)="save()"
      [disabled]="affiliationId === undefined"
      class="btn btn-primary-migrated"
    >
      {{ 'common.actions.save' | translate }}
    </button>
  </div>
</div>
